import React from "react";

import {
  Button,
  ButtonTypes,
  Card,
  ExternalLinkIcon,
  Text,
  TextColors,
  TextTypes,
} from "../../../../component-library";
import { ICON_SIZES, ICON_TYPES } from "../../../../constants/icons";

const payBillUrl =
  "https://www.medentlink.com/openedge/guestpay/index.php?practice_id=AE5sjG3S&auth_key=15147750-8015-11eb-9439-0242ac130002";

const PayBillSection = () => {
  return (
    <Card className="CardSection">
      <Text type={TextTypes.heading2} color={TextColors.black}>
        Online Bill Pay
      </Text>
      <div className={"PayBillSection--content"}>
        <Text className={"PayBillSection--text"} type={TextTypes.paragraph} color={TextColors.grey}>
          Pay your bill online using the information from your statement.
        </Text>
        <Button
          className={"PayBillSection--button"}
          buttonType={ButtonTypes.primaryV2}
          onClick={() => {
            window.open(payBillUrl, "_blank");
          }}
        >
          {"Pay Bill"}
          <ExternalLinkIcon
            className={"PayBillSection--link-icon"}
            iconType={ICON_TYPES.OUTLINE}
            iconSize={ICON_SIZES.SMALL}
          />
        </Button>
      </div>
    </Card>
  );
};

export default PayBillSection;
